/**
 * @fileoverview スクロール連動フェードイン制御
 * @description viewport内に入った要素に状態クラスを付与する
 */

/**
 * フェードイン対象要素
 */
const fadeinTargets = document.querySelectorAll('.js-fadein');

if (fadeinTargets.length) {
	/**
	 * KV内の要素かどうかを判定
	 */
	const kvSection = document.querySelector('.p-home-kv');
	const isKvElement = (element) => {
		return kvSection && kvSection.contains(element);
	};

	/**
	 * KVロゴ（ロード時に即表示させたい要素）
	 */
	const kvLogo = kvSection?.querySelector('.p-home-kv__copy-logo');

	/**
	 * KV要素を遅延監視するための一時リスト
	 */
	const kvTargets = [];

	/**
	 * 通常のIntersectionObserver設定（少し手前で発火）
	 */
	const normalObserver = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;

				/**
				 * 表示トリガー
				 */
				entry.target.classList.add('is-fadein');

				/**
				 * 一度表示した要素は監視解除
				 */
				obs.unobserve(entry.target);
			});
		},
		{
			/**
			 * 少し手前で発火させる
			 */
			rootMargin: '0px 0px -30% 0px'
		}
	);

	/**
	 * KV内専用のIntersectionObserver設定（早めに発火）
	 */
	const kvObserver = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;

				/**
				 * 表示トリガー
				 */
				entry.target.classList.add('is-fadein');

				/**
				 * 一度表示した要素は監視解除
				 */
				obs.unobserve(entry.target);
			});
		},
		{
			/**
			 * KV内は早めに発火させる（-10%）
			 */
			rootMargin: '0px 0px -50% 0px'
		}
	);

	/**
	 * 対象要素を監視開始（KV内かどうかで分岐）
	 */
	fadeinTargets.forEach(el => {
		if (isKvElement(el)) {
			if (kvLogo && kvLogo.contains(el)) {
				kvObserver.observe(el);
			} else {
				kvTargets.push(el);
			}
		} else {
			normalObserver.observe(el);
		}
	});

	/**
	 * スクロール開始まではKV要素を監視しない
	 */
	const startKvObservation = () => {
		kvTargets.forEach(target => kvObserver.observe(target));
		kvTargets.length = 0;
	};

	if (kvTargets.length) {
		if (window.scrollY > 0) {
			startKvObservation();
		} else {
			window.addEventListener('scroll', startKvObservation, {
				once: true,
				passive: true,
			});
		}
	}
}
